import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../../layout/PageHeader';
import PageMainContent from '../../../layout/PageMainContent';
import { LOGO_SIZE } from '../../../ui/Logo';
import PublicPageLayout from '../../../layout/PublicPageLayout';
const getStorageKey = (language) => `USAGE_AGREEMENT_URL_${language.toUpperCase()}`;
const getCachedUsageAgreementUrl = (language) => {
    try {
        return localStorage.getItem(getStorageKey(language));
    }
    catch {
        return null;
    }
};
const getContactEmail = () => {
    const user = 'compass';
    const domain = ['kindervereinigung-chemnitz', 'de'].join('.');
    return `${user}@${domain}`;
};
const BecomeCreatorPage = () => {
    const { t, i18n } = useTranslation();
    const contactEmail = getContactEmail();
    const [usageAgreementUrl, setUsageAgreementUrl] = useState(null);
    useEffect(() => {
        const cachedUrl = getCachedUsageAgreementUrl(i18n.language);
        if (cachedUrl) {
            setUsageAgreementUrl(cachedUrl);
            return;
        }
        const fetchApprovalForm = async () => {
            try {
                const response = await fetch(`/_api/approval-form?lang=${i18n.language}`);
                if (response.ok) {
                    const data = await response.json();
                    if (data.uri) {
                        localStorage.setItem(getStorageKey(i18n.language), data.uri);
                        setUsageAgreementUrl(data.uri);
                    }
                }
            }
            catch {
                // Silently fail - link won't be shown if endpoint fails
            }
        };
        fetchApprovalForm();
    }, [i18n.language]);
    return (_jsx(PublicPageLayout, { children: _jsxs("div", { className: "page-content-wrapper become-creator-page", children: [_jsx(PageHeader, { logoSize: LOGO_SIZE.FULL, logoLink: "/" }), _jsx(PageMainContent, { children: _jsxs("div", { className: "become-creator-content", children: [_jsx("h1", { className: "become-creator-title", children: t('become_creator.title') }), _jsx("p", { className: "become-creator-description", children: t('become_creator.description') }), _jsx("h2", { className: "become-creator-subtitle", children: t('become_creator.how_it_works') }), _jsxs("ol", { className: "become-creator-steps", children: [_jsxs("li", { children: [t('become_creator.step_1', { email: contactEmail }), _jsxs("ul", { className: "become-creator-steps", children: [_jsx("li", { children: t('become_creator.step_1_1') }), _jsx("li", { children: t('become_creator.step_1_2') }), _jsx("li", { children: t('become_creator.step_1_3') })] })] }), _jsx("li", { children: t('become_creator.step_2') }), _jsx("li", { children: t('become_creator.step_3') }), _jsx("li", { children: t('become_creator.step_4') })] }), usageAgreementUrl && (_jsx("a", { href: usageAgreementUrl, className: "become-creator-link", target: "_blank", rel: "noopener noreferrer", children: t('become_creator.usage_agreement') })), _jsx("a", { href: `mailto:${contactEmail}`, className: "become-creator-email-button", children: t('become_creator.email_button', { email: contactEmail }) })] }) })] }) }));
};
export default BecomeCreatorPage;
